import { CostItemUI } from './CostGetResponse';

export const EmptyCostDeleteItem: CostItemUI = {
  id: 0,
  costCategoryId: 0,
  category: '',
  detail: '',
  date: '',
  price: 0,
};
